import { jsx as _jsx } from "react/jsx-runtime";
import { configurationSettings, LoyaltyMemberIdentifier } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { AutoCompleteType } from '../../subcomponents/form/auto-complete-type';
import { CaptchaField } from '../../subcomponents/form/field/captcha/captcha-field';
import { CheckboxField } from '../../subcomponents/form/field/checkbox/checkbox-field';
import { CurrentPasswordField } from '../../subcomponents/form/field/current-password/current-password-field';
import { InputField } from '../../subcomponents/form/field/input/input-field';
import { getFieldClassName, getFieldId } from '../../subcomponents/form/field/utils/field-attribute-utils';
import { InvalidFieldNameError } from '../../types/invalid-field-name-error';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { MemberSignInFormContextInstance } from '../member-sign-in-form/types/context';
import { MemberSignInFormFieldName } from './types/name';
import { defaultMemberSignInFormFieldPropsProvider, memberSignInFormFieldPropsValidator } from './types/props';
const b = bemClassBuilder('v-member-sign-in-form-field');
const MemberSignInFormField = observer((props) => {
    const { onChange, validationConfig, validator, formData, validationResult, disabled } = useContext(MemberSignInFormContextInstance);
    const { memberIdentifier } = configurationSettings.data.loyalty.authentication;
    const getCommonFieldProps = (key) => {
		
		const returnProps = {
        id: getFieldId(b, key),
        name: key,
        className: getFieldClassName(b, key),
        error: validationResult.validationErrors[key],
        disabled
		};
	
		if(key === 'captcha' && props?.captchaRef) {
			console.log("captcha props", props)
			returnProps.captchaRef = props.captchaRef; // Hack - added captchaRef to captcha field to allow for reset
		}
	
		return returnProps;
	
	};
    switch (props.name) {
        case MemberSignInFormFieldName.Identifier: {
            if (memberIdentifier === LoyaltyMemberIdentifier.Email) {
                const key = 'email';
                return (_jsx(InputField, Object.assign({}, getCommonFieldProps(key), { type: "email", displayText: props.displayText, value: formData[key], validationConfig: validationConfig[key], autoCompleteType: AutoCompleteType.Email, validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
            }
            const key = 'username';
            return (_jsx(InputField, Object.assign({}, getCommonFieldProps(key), { displayText: props.displayText, value: formData[key], autoCompleteType: AutoCompleteType.Username, validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
        }
        case MemberSignInFormFieldName.Password: {
            const key = 'password';
            return (_jsx(CurrentPasswordField, Object.assign({}, getCommonFieldProps(key), { displayText: props.displayText, value: formData[key], validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
        }
        case MemberSignInFormFieldName.Remember: {
            const key = 'remember';
            return (_jsx(CheckboxField, Object.assign({}, getCommonFieldProps(key), { showLabel: false, displayText: props.displayText, value: formData[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
        }
        case MemberSignInFormFieldName.Captcha: {
            const key = 'captcha';
            return (_jsx(CaptchaField, Object.assign({}, getCommonFieldProps(key), { displayText: props.displayText, validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
        }
        default:
            throw new InvalidFieldNameError('MemberSignInFormField', props.name);
    }
});
MemberSignInFormField.displayName = 'MemberSignInFormField';
export const MemberSignInFormFieldComponent = withComponentWrapper(MemberSignInFormField, defaultMemberSignInFormFieldPropsProvider, memberSignInFormFieldPropsValidator);
